import React, { useEffect, useState } from 'react';
import './BetHistoryPage.css';
import { authService } from '../services/authService';

const WithdrawHistory = () => {
  const [loading, setLoading] = useState(true);
  const [history, setHistory] = useState([]);
  const [error, setError] = useState('');
  const [timeInfo, setTimeInfo] = useState({});

  useEffect(() => {
    const fetchWithdrawHistory = async () => {
      const token = authService.getToken();
      if (!token) {
        setError('Session expired. Please login again.');
        setLoading(false);
        return;
      }

      try {
        const res = await fetch(
          'https://playinbyd.com/api/api-user-withdraw-transaction-history',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              app_key: 'SgRTXsywVmWteEBLlYWecwgbDiHwlh',
              env_type: 'Prod',
              unique_jwt_token: token
            })
          }
        );

        const data = await res.json();

        if (data.success) {
          setHistory(data.withdrawdata || []);
          setTimeInfo({
            open: data.withdraw_open_time,
            close: data.withdraw_close_time,
            wallet: data.wallet_amt
          });
        } else {
          setHistory([]);
        }
      } catch (err) {
        console.error(err);
        setError('Failed to load withdrawal history');
      } finally {
        setLoading(false);
      }
    };

    fetchWithdrawHistory();
  }, []);

  const getStatusLabel = (status) => {
    switch (status) {
      case '1':
        return { text: 'Approved', class: 'status-open' };
      case '2':
        return { text: 'Rejected', class: 'status-pending' };
      default:
        return { text: 'Pending', class: 'status-pending' };
    }
  };

  return (
    <div className="bet-history-page">
      {/* HEADER */}
      <div className="page-header">
        <div>
          <h1 className="page-title">Withdrawal History</h1>
          <p className="page-subtitle">
            View all your withdrawal requests
          </p>
        </div>

        {timeInfo.wallet !== undefined && (
          <div className="user-info-card">
            <div className="user-details">
              <div className="user-name">
                Wallet Balance: ₹{timeInfo.wallet}
              </div>
              <div className="user-mobile">
                Withdraw Time: {timeInfo.open} – {timeInfo.close}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* CONTENT */}
      <div className="content-card">
        {loading ? (
          <div className="loading-state">
            <div className="spinner"></div>
            <p>Loading withdrawal history...</p>
          </div>
        ) : error ? (
          <div className="empty-state">
            <div className="empty-icon">⚠️</div>
            <p>{error}</p>
          </div>
        ) : history.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">💸</div>
            <h3>No Withdrawals Found</h3>
            <p>You have not made any withdrawal requests yet.</p>
          </div>
        ) : (
          <>
            <div className="table-container">
              <table className="bet-history-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>AMOUNT</th>
                    <th>STATUS</th>
                    <th>REQUEST ID</th>
                    <th>BANK</th>
                    <th>ACCOUNT</th>
                    <th>DATE</th>
                  </tr>
                </thead>
                <tbody>
                  {history.map((item, index) => {
                    const status = getStatusLabel(item.fund_status);

                    return (
                      <tr key={item._id}>
                        <td className="serial-number">{index + 1}</td>

                        <td className="points-cell">
                          <span className="points-value">
                            ₹{item.amount}
                          </span>
                        </td>

                        <td>
                          <span className={`status-badge ${status.class}`}>
                            {status.text}
                          </span>
                        </td>

                        <td className="serial-number">
                          {item.tx_request_number}
                        </td>

                        <td>{item.bank_name}</td>

                        <td>
                          ****{item.ac_number?.slice(-4)}
                        </td>

                        <td className="date-time-cell">
                          {item.insert_date}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="table-footer">
              <div className="footer-info">
                Showing <strong>{history.length}</strong> records
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default WithdrawHistory;
